import { AncillaryInt } from "@interfaces/*";
export class Ancillaries {
  _collection = [];
  ancillaryBuilders = [];

  constructor(ancillaries: AncillaryInt[]) {
    if (ancillaries && ancillaries.length > 0) {
      for (let index = 0; index < ancillaries.length; index++) {
        let ancillary:any = ancillaries[index];
        let ancillaryBuilder = this.getAncillaryBuilder(ancillary);
        let builtAncillary = null;
        if (ancillaryBuilder != null) {
          builtAncillary = ancillaryBuilder.buildFromApi(ancillary);
        } else {
          if (ancillary?.ancillary == null || ancillary?.ancillary?.currency == null || ancillary?.ancillary?.currency.total == null || ancillary?.ancillary?.currency.total == 0) {
            continue;
          }
          builtAncillary = ancillary;
        }
        this.addAncillary(builtAncillary);
      }
    }
  }



  private getAncillaryBuilder(ancillary) {
    for (var index = 0; index < this.ancillaryBuilders.length; index++) {
      var ancillaryBuilder = this.ancillaryBuilders[index];
      if (ancillaryBuilder.accepts(ancillary)) {
        return ancillaryBuilder;
      }
    }
    return null;
  }

  /**
   * Adds an ancillary if it is not already added
   * @param ancillary Ancillary to add
   */
  addAncillary(ancillary) {
    this.removeAncillary(ancillary);
    this._collection.push(ancillary);
  }

  /**
   * Combines ancillary objects, will not duplicate ancillaries
   * @param ancillaries
   */
  merge(ancillaries) {
    if (ancillaries == null) {
      throw "Invalid input for merge! ";
    }
    for (var index = 0; index < ancillaries._collection.length; index++) {
      var ancillary = ancillaries._collection[index];
      this.addAncillary(ancillary);
    }
  }

  /**
   * Finds a matching ancillary by getId()
   * @param ancillaryToFind
   * @return {*}
   */
  findAncillary(ancillaryToFind) {
    for (var index = 0; index < this._collection.length; index++) {
      var ancillary = this._collection[index];
      if (ancillary.getId() == ancillaryToFind.getId()) {
        return ancillary;
      }
    }
    return null;
  }

  removeAncillary(ancillaryToRemove) {
    for (var index = 0; index < this._collection.length; index++) {
      var ancillary = this._collection[index];
      if (ancillary.getId() == ancillaryToRemove.getId()) {
        this._collection.splice(index, 1);
      }
    }
    return null;
  }

  clearPremiereUpgrade() {
    for (var index = 0; index < this._collection.length; index++) {
      var ancillary = this._collection[index];
      ancillary.clearPremiereUpgrade();
    }
  }

  isEmpty() {
    return this._collection == null || this._collection.length == 0;
  }

  prepareForCall() {
    for (var index = 0; index < this._collection.length; index++) {
      var ancillary = this._collection[index];
      if (ancillary.prepareForCall != null) {
        ancillary.prepareForCall();
      }
    }
  }
}
